/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_LoadingInputs */



/**
* | output |
* | --- |
* | "Loading your 1:1s…" |
*
* @param {Team_LoadingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_loading = /** @type {((inputs?: Team_LoadingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_LoadingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je 1:1's worden geladen…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement de vos one-to-ones…")
	return /** @type {LocalizedString} */ ("Loading your 1:1s…")
});